import React, { useEffect, useState } from "react";
import { MailOutline } from "@material-ui/icons";
import CardHeader from "components/Card/CardHeader";
import CardIcon from "components/Card/CardIcon";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Card from "components/Card/Card";
import styles from "assets/jss/material-dashboard-pro-react/views/formsStyle.js";
import CardBody from "components/Card/CardBody";
import { FormControl, Input, InputLabel, makeStyles } from "@material-ui/core";
import PropTypes from "prop-types";
import Button from "components/CustomButtons/Button.js";
import CustomInput from "components/CustomInput/CustomInput";
import { Redirect } from "react-router-dom";
import YuuTransactionDialog from "components/YuuTransctionDialog/YuuTransactionDialog";
import { yuuApi } from "functions/apis";

const useStyles = makeStyles(styles);

const emptyBody = {
  transactionID: null,
  description: "",
  amount: 0
};

export default function CreateYuuClawback(props) {
  const classes = useStyles();
  const createYuuClawback = new AbortController();

  const [input, setInput] = useState({ ...emptyBody });
  const [showModal, setShowModal] = useState(false);
  const [redirect, setRedirect] = useState(false);
  const [disabled, setDisabled] = useState(false);

  const [transactionData, setTransactionData] = useState({
    id: "",
    description: ""
  });

  useEffect(() => {
    return () => createYuuClawback.abort("");
  }, []);

  const handleTransactionIDChanged = e => {
    setShowModal(false);
    setTransactionData(prev => ({
      ...prev,
      id: e.id === "" ? null : e.id,
      description: e.description
    }));
  };

  const handleDescriptionChanged = e =>
    setInput({
      ...input,
      description: e.target?.value === "" ? null : e.target.value
    });

  const handleAmountChanged = e =>
    setInput({
      ...input,
      amount: e.target?.value === "" ? null : e.target.value
    });

  const handleSubmit = e => {
    e.preventDefault();
    setDisabled(true);
    yuuApi
      .post(
        "/ClawBacks",
        {
          ...input,
          transactionID: transactionData.id
        },
        {
          signal: createYuuClawback.signal
        }
      )
      .then(() => setRedirect(true))
      .finally(() => {
        setDisabled(false);
      });
  };

  return redirect ? (
    <Redirect to={"/admin/YuuClawback/Enqueued"} />
  ) : (
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="rose">
              <MailOutline />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>CREATE YUU CLAWBACK</h4>
          </CardHeader>
          <CardBody>
            <Button onClick={() => props.history.goBack()} value="Back">
              BACK
            </Button>
            <form onSubmit={handleSubmit}>
              <GridContainer>
                <GridItem xs={12}>
                  <FormControl fullWidth className={classes.selectFormControl}>
                    <InputLabel
                      htmlFor="selTransaction"
                      className={classes.selectLabel}
                    >
                      Transaction
                    </InputLabel>
                    <Input
                      onClick={() => setShowModal(prev => !prev)}
                      className={classes.select}
                      value={
                        transactionData && transactionData.description
                          ? transactionData.description
                          : ""
                      }
                    />
                    <YuuTransactionDialog
                      openModal={showModal}
                      setOpenModal={val => setShowModal(val)}
                      onSelect={handleTransactionIDChanged}
                    />
                  </FormControl>
                </GridItem>
                <GridItem xs={12}>
                  <CustomInput
                    labelText="Description"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      onChange: handleDescriptionChanged,
                      value: input.description === null ? "" : input.description
                    }}
                  />
                </GridItem>
                <GridItem xs={12}>
                  <CustomInput
                    labelText="Amount"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      type: "number",
                      onChange: handleAmountChanged,
                      value: input.amount
                    }}
                  />
                </GridItem>
              </GridContainer>
              <Button
                disabled={disabled}
                color="rose"
                type="submit"
                value="Submit"
              >
                Submit
              </Button>
            </form>
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
}

CreateYuuClawback.propTypes = {
  history: PropTypes.object
};
